import React from "react";
import {BackgroundImage, ServicePage,TeethLogo} from "../../Components"

const Service = (props) => {

    const { selectedLanguage } = props
    return(
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.services_heading} text={selectedLanguage?.txt_your_perfect_smile_is_waiting_for_you}/>
            <TeethLogo heading={selectedLanguage?.services_heading} text1={selectedLanguage?.services_paragraph}/>
            <ServicePage {...props}/>
        </div>
    )
}

export default Service